<div class="row" style="margin-bottom: 30px;">
    <div class="col-md-12 text-center">
        <h1>Select Occupation</h1>
    </div>
</div>
<div style="padding: 10px; overflow-y: auto;" [className]="size.small ? 'loading mobile-dialog-height' : 'loading'">
    <div class="row animate1 fadeIn">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="wp100 bold">
                <mat-label>Search</mat-label>
                <input matInput placeholder="Search..." (keyup)="applyFilter($event.target.value)">
                <i matSuffix class="secondary-text fas fa-search"></i>
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover table-condensed">

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="bolder fs18 c-dark-grey" style="vertical-align:middle"> Name </th>
                    <td mat-cell *matCellDef="let row" class="wp90 bold fs14" style="vertical-align:middle"> {{row.name}} </td>
                </ng-container>

                <!-- Code Column -->
                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="vertical-align:middle;" class="bold fs18 c-dark-grey"> Code </th>
                    <td mat-cell *matCellDef="let row" class="wp10 bold fs14 c-purple text-center" style="vertical-align:middle"> {{row.code}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectOccupation(row)">
                </tr>
            </table>
            <mat-paginator [pageSizeOptions]="[10]"></mat-paginator>
        </div>
        <div class="col-md-12 text-center">
            <button mat-raised-button (click)="close()"> <i class="fas fa-times"></i> Close</button>
        </div>
        <!-- <ngx-loading [show]="occloading"></ngx-loading> -->
        <ngx-loading [show]="occloading" [config]="{ animationType: ngxLoadingAnimationTypes.rotatingPlane,
            backdropBackgroundColour: 'rgba(255,255,255,1)', backdropBorderRadius: '10px',
            primaryColour: '#666666', secondaryColour: '#666666', tertiaryColour: '#666666' }"></ngx-loading>
    </div>
</div>